// Where clicking a notification should go. New alerts carry their own link; older ones were saved without one,
// so the target is worked out from the alert's kind and title.
export const alertTarget = (alert) => {
    if (!alert) return '';
    // booking alerts saved before the tab was added pointed at the plain provider page
    if (alert.type === 'booking' && alert.link === '/service-provider') return '/service-provider?tab=bookings';
    if (alert.link) return alert.link;
    if (alert.type === 'interest') return '/dashboard?tab=interests';
    if (alert.type === 'message') return /support/i.test(alert.title || '') ? '/messages?with=support' : '/messages';
    if (alert.type === 'like') return '/dashboard?tab=interests';
    if (alert.type === 'contact') return /approved|declined/i.test(alert.title || '') ? '/dashboard?tab=interests' : '/dashboard?tab=settings';
    return '/notifications';
};
